if (!customElements.get('aeo-timeline-slider')) {
  customElements.define(
    'aeo-timeline-slider',
    class AeoTimelineSlider extends HTMLElement {
      constructor() {
        super();

        this.onSectionLoad = this.onSectionLoad.bind(this);
        this.onSectionReorder = this.onSectionReorder.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onEditorMutate = this.onEditorMutate.bind(this);
      }

      connectedCallback() {
        this.slider = this;
        this.section = this.closest('.shopify-section');
        this.sectionId = this.section?.id?.replace('shopify-section-', '');
        this.sliderInstance = false;
        this.refreshTimer = null;

        if (Shopify.designMode) {
          this.observeEditorMutations();
          document.addEventListener('shopify:section:load', this.onSectionLoad);
          document.addEventListener('shopify:section:reorder', this.onSectionReorder);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        if (this.querySelectorAll('.swiper-slide').length < 1) return;

        this.initSlider();
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }

        if (this.refreshTimer) {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = null;
        }

        if (Shopify.designMode) {
          document.removeEventListener('shopify:section:load', this.onSectionLoad);
          document.removeEventListener('shopify:section:reorder', this.onSectionReorder);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        this.destroySlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') {
          this.destroySlider();
        }

        if (this.querySelectorAll('.swiper-slide').length < 1) return;

        const sectionRoot = this.closest('.section--aeo-timeline') || this.section;
        const nextEl = sectionRoot?.querySelector('.swiper-btn-next') || null;
        const prevEl = sectionRoot?.querySelector('.swiper-btn-prev') || null;

        const slidesPerViewMobile = parseFloat(this.dataset.itemsMobile || '1.25');
        const slidesPerViewDesktop = parseFloat(this.dataset.itemsDesktop || '4.5');

        this.sliderInstance = new window.FoxTheme.Carousel(this.slider, {
          slidesPerView: slidesPerViewMobile,
          spaceBetween: 16,
          breakpoints: {
            1024: {
              slidesPerView: slidesPerViewDesktop,
              spaceBetween: 24,
            },
          },
          navigation: {
            nextEl,
            prevEl,
          },
          loop: false,
          threshold: 2,
          grabCursor: true,
          watchSlidesProgress: true,
          allowTouchMove: true,
        });

        this.sliderInstance.init();
      }

      scheduleRefresh(delay = 60) {
        if (this.refreshTimer) {
          clearTimeout(this.refreshTimer);
        }

        this.refreshTimer = setTimeout(() => {
          this.refreshTimer = null;
          if (!this.isConnected) return;
          this.initSlider();
        }, delay);
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;

        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      getEventSectionId(event) {
        return (
          event?.detail?.sectionId
          || event?.target?.id?.replace('shopify-section-', '')
          || event?.target?.closest?.('.shopify-section')?.id?.replace('shopify-section-', '')
          || ''
        );
      }

      observeEditorMutations() {
        const wrapper = this.querySelector('.swiper-wrapper');
        if (!wrapper) return;

        this.observer = new MutationObserver(this.onEditorMutate);
        this.observer.observe(wrapper, {
          childList: true,
        });
      }

      onEditorMutate(mutations) {
        const changedChildren = mutations.some((mutation) => mutation.type === 'childList');
        if (!changedChildren) return;

        this.scheduleRefresh(80);
      }

      onSectionLoad(event) {
        const eventSectionId = this.getEventSectionId(event);
        if (!this.sectionId || eventSectionId !== this.sectionId) return;

        this.scheduleRefresh(0);
      }

      onSectionReorder(event) {
        const eventSectionId = this.getEventSectionId(event);
        if (!this.sectionId || eventSectionId !== this.sectionId) return;

        this.scheduleRefresh(0);
      }

      onBlockSelect(event) {
        const eventSectionId = this.getEventSectionId(event);
        if (!this.sectionId || eventSectionId !== this.sectionId) return;

        if (typeof this.sliderInstance !== 'object' || !this.sliderInstance.slider) {
          this.initSlider();
        }

        if (typeof this.sliderInstance !== 'object' || !this.sliderInstance.slider) return;

        const index = Number(event.target.dataset.index);
        if (Number.isNaN(index)) return;

        this.sliderInstance.slider.slideTo(index);
      }
    }
  );
}
